import React, { Component } from 'react';
import { arrayOf, bool, func, number, object, oneOfType, shape, string } from 'prop-types';
import SurveyJobMatchesHeader from './SurveyJobMatchesHeader/SurveyJobMatchesHeader';
import SurveyJobMatchesList from './SurveyJobMatchesList/SurveyJobMatchesList';
import SurveyJobMatchesSubHeader from './SurveyJobMatchesSubHeader/SurveyJobMatchesSubHeader';
import Placeholder from 'ps-components/Placeholder/Placeholder';
import Button from 'ps-components/Button/Button';

import './SurveyJobMatches.scss';

import { addOrRemoveSurveyJobByCode } from '../../JobMatching/SurveyJobsActions';

class SurveyJobMatches extends Component {
  static propTypes = {
    history: object,
    selectedJob: shape({
      code: string,
      codeKey: string,
      currency: string,
      description: string,
      fileLocation: string,
      fileTitle: string,
      employeeCount: oneOfType([string, number]),
      id: oneOfType([string, number]),
      jobMatches: arrayOf(
        shape({
          id: string,
          orgJob: shape({
            id: string
          }),
          surveyJob: shape({
            code: string,
            description: string,
            id: string,
            survey: shape({
              code: string,
              id: string,
              name: string
            }),
            title: string
          })
        })
      ),
      name: string
    }),
    showSlideout: func,
    showSurveyJobDescription: bool,
    toggleJobDescriptionSetting: func,
    addOrRemoveSurveyJob: func,
    clearSelectedSurveyJobs: func,
    bulkSelectSurveyJobs: func,
    selectedSurveyJobs: arrayOf(string),
    replacementTokens: arrayOf(
      shape({
        token: string,
        value: string
      })
    ),
    useJobCodeKey: bool
  };

  constructor(props) {
    super(props);

    this.openModal = this.openModal.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { selectedJob, clearSelectedSurveyJobs } = this.props;

    if (
      selectedJob.id !== prevProps.selectedJob.id ||
      (selectedJob.jobMatches &&
        prevProps.selectedJob.jobMatches &&
        selectedJob.jobMatches.length < prevProps.selectedJob.jobMatches.length)
    ) {
      clearSelectedSurveyJobs();
    }
  }

  selectAllSurveyJobMatches = () => {
    const { selectedJob, selectedSurveyJobs, bulkSelectSurveyJobs } = this.props;
    if (selectedSurveyJobs.length === selectedJob.jobMatches.length) {
      bulkSelectSurveyJobs([]);
    } else {
      const allIds = selectedJob.jobMatches.map(job => {
        if (job.id.includes('::')) {
          return job.id;
        }

        return job.surveyJob.id;
      });
      bulkSelectSurveyJobs(allIds);
    }
  };

  openModal() {
    const { history, selectedJob } = this.props;

    history.push(`/market-analysis/jobs/${selectedJob.id}/edit-matches`, {
      component: 'SURVEY_JOB_MATCHING',
      modal: true,
      modalProps: { className: 'job-matching__modal', orgJob: selectedJob },
      modalType: 'SURVEY_JOB_MATCHING'
    });
  }

  render() {
    const {
      selectedSurveyJobs,
      selectedSurveyJobCodes,
      history,
      selectedJob,
      showSlideout,
      showSurveyJobDescription,
      toggleJobDescriptionSetting,
      addOrRemoveSurveyJob,
      clearSelectedSurveyJobs,
      replacementTokens,
      useJobCodeKey
    } = this.props;

    const buttonText = 'Add Matches';

    return (
      <div className="matches__panel">
        <SurveyJobMatchesHeader
          history={history}
          selectedJob={selectedJob}
          replacementTokens={replacementTokens}
          useJobCodeKey={useJobCodeKey}
        />
        {selectedJob.jobMatches && selectedJob.jobMatches.length > 0 ? (
          <React.Fragment>
            <SurveyJobMatchesSubHeader
              clearSelectedSurveyJobs={clearSelectedSurveyJobs}
              history={history}
              selectedJob={selectedJob}
              selectedSurveyJobs={selectedSurveyJobCodes}
              showSlideout={showSlideout}
              showSurveyJobDescription={showSurveyJobDescription}
              toggleJobDescriptionSetting={toggleJobDescriptionSetting}
            />
            <SurveyJobMatchesList
              onSurveyJobClick={addOrRemoveSurveyJob}
              selectAllSurveyJobMatches={this.selectAllSurveyJobMatches}
              selectedJob={selectedJob}
              selectedSurveyJobs={selectedSurveyJobCodes}
              showSurveyJobDescription={showSurveyJobDescription}
            />
          </React.Fragment>
        ) : (
          <Placeholder
            className="pxl-text-small pxl-text-muted"
            imagePath="/view/static/mp/images/empty_results.svg"
            secondaryText="You have not selected any matches for this job."
            showText={true}
          >
            <Button className="matches__btn pxl-btn pxl-btn-primary pxl-btn-sm" onClick={this.openModal}>
              {buttonText}
            </Button>
          </Placeholder>
        )}
      </div>
    );
  }
}

export default SurveyJobMatches;
